import { render, staticRenderFns } from "./MijnBewijzen.vue?vue&type=template&id=4870aa71&scoped=true"
import script from "./MijnBewijzen.vue?vue&type=script&lang=js"
export * from "./MijnBewijzen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4870aa71",
  null
  
)

export default component.exports